import React from "react";
import useTranslation from "hooks/useTranslation";

export default ({ group }) => {
  const { t } = useTranslation();

  return group.name || <em>{t`group.nameless`}</em>;
};
